var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6659 0.49952C16.4003 0.70103 16.9786 1.29478 17.1749 2.04878C17.5315 3.41533 17.5315 6.26663 17.5315 6.26663C17.5315 6.26663 17.5315 9.11784 17.1749 10.4845C16.9786 11.2385 16.4003 11.8322 15.6659 12.0338C14.3351 12.4 8.99818 12.4 8.99818 12.4C8.99818 12.4 3.66126 12.4 2.33035 12.0338C1.596 11.8322 1.01767 11.2385 0.821401 10.4845C0.464844 9.11784 0.464844 6.26663 0.464844 6.26663C0.464844 6.26663 0.464844 3.41533 0.821401 2.04878C1.01767 1.29478 1.596 0.70103 2.33035 0.49952C3.66126 0.133301 8.99818 0.133301 8.99818 0.133301C8.99818 0.133301 14.3351 0.133301 15.6659 0.49952ZM7.39819 3.86658V9.19991L11.6649 6.53335L7.39819 3.86658Z",
    fill: "#0EC99E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.475f44431963065b422b0bc0327cbad1.svg";
export { ForwardRef as ReactComponent };